/**
 * Domains reserved for examples by RFC 2606, so mail to them is never delivered. The IMT converter
 * gives migrated accounts with no email a `forreston-import-<accountId>@example.com` Cognito email,
 * because Cognito requires one (cron-be/imt-converter cognito-user-service.ts, #31411).
 */
const PLACEHOLDER_EMAIL_DOMAINS = ['example.com', 'example.net', 'example.org'];

/**
 * True for an email that can't receive mail (a migration placeholder). Treat it like no email: an
 * invoice "emailed" to it never arrives, so it has to go by letter instead. (#36708)
 */
export function isPlaceholderEmail(email: string | null | undefined): boolean {
  const domain = email?.trim().toLowerCase().split('@')[1];
  return !!domain && PLACEHOLDER_EMAIL_DOMAINS.includes(domain);
}
